import { type TeamMode } from "@common/constants";
import type { ModeName } from "@common/definitions/modes";

export const Config = {
    regions: {
        delarosa: {
            name: "Delarosa Family",
            mainAddress: "https://suroi.delarosafams.com",
            gameAddress: "wss://suroi.delarosafams.com/game/<gameID>",
            offset: 8001
        }
    },
    defaultRegion: "delarosa"
} satisfies ConfigType as ConfigType;
